import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import cogoToast from "cogo-toast";
import Loader from "react-loader-spinner";
import moment from "moment";
import invoiceService from "../services/invoice-service";
import stockService from "../services/stock-service";
const UploadInvoice = ({ history, totalMonths, parentsList, totalYears }) => {
  const { register, getValues, reset } = useForm({});
  const [loading, setLoading] = useState(false);
  const [facSelected, setFacSelected] = useState("");
  const [parentSelected, setParSelected] = useState("");
  const [disableInvProp, setInvDisableProp] = useState("disabled");
  const [disableOthrProp, setOthrDisableProp] = useState("disabled");
  const [facList, setFacList] = useState([]);
  const [eraseExisting, setEraseExisting] = useState("");
  const [othrMonthSelected, setOthrMonthSelected] = useState(false);
  const [invoiceEraseExisting, setInvoiceEraseExisting] = useState("");
  const [invoiceMonthSelected, setInvoiceMonthSelected] = useState(false);
  const invoiceFileUpload = async (event) => {
    let formData1 = new FormData();
    let invoice_month = getValues("invoice_month");
    let invoice_year = getValues("invoice_year");
    let invoice_month_othr = getValues("invoice_month_othr");
    let invoice_year_othr = getValues("invoice_year_othr");
    let fileType = event.target.name.toUpperCase();
    formData1.append("excel", event.target.files[0]);
    if (fileType !== "ADDRESS") {
      if (fileType === "INVOICE") {
        formData1.append("year", invoice_year);
        formData1.append("month", invoice_month);
        formData1.append("erase_existing", invoiceEraseExisting);
      } else {
        formData1.append("payor", parentSelected);
        formData1.append("group", facSelected);
        formData1.append("year", invoice_year_othr);
        formData1.append("month", invoice_month_othr);
        formData1.append("erase_existing", eraseExisting);
      }
    }
    formData1.append("file_type", fileType);
    try {
      setLoading(true);
      const response = await invoiceService.uploadInvoiceFile(formData1);
      if (response) {
        reset({});
        const { hide } = cogoToast.success(
          "Invoice File Uploaded Successfully!!",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error uploading Invoice File. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  async function getFacilities(parentId) {
    if (parentId !== "") {
      try {
        setLoading(true);
        let resp = await stockService.getFacByParent(parentId);
        resp.sort((a, b) => a.name.localeCompare(b.name));
        setFacList(resp);
        setLoading(false);
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error while getting facilities details. Please try after sometime.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
        setLoading(false);
      }
    }
  }

  const totalYearsList = () => {
    return totalYears().map((i) => (
      <option value={i} key={i}>
        {i}
      </option>
    ));
  };
  return (
    <div className="">
      <div
        className={`inline-block customtop z-50 absolute ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000}
        />
      </div>
      <div className={`inline-block w-full px-10 pb-4 border-b-2`}>
        <div className="pb-4 border-b-2">
          <ul className="text-left">
            <li className="inline-block text-xs leading-8 w-1/2 mb-4">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Report Month
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="invoice_month"
                aria-label="Select Report Month"
                ref={register({
                  required: true,
                })}
                onChange={(e) => {
                  const monthSelected = e.target.value !== " ";
                  setInvoiceMonthSelected(monthSelected);
                  if (monthSelected && invoiceEraseExisting !== "") {
                    setInvDisableProp("");
                  } else {
                    setInvDisableProp("disabled");
                  }
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-11/12 text-fogotpwsd_login text-sm"
              >
                <option value=" ">Select Report Month</option>
                {totalMonths
                  ? totalMonths.map((monthName, i) => {
                      return (
                        <option key={i} value={("0" + (i + 1)).slice(-2)}>
                          {monthName}
                        </option>
                      );
                    })
                  : null}
              </select>
            </li>
            <li className="inline-block text-xs leading-8 w-1/2 mb-4">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Report Year
              </label>
              <select
                name="invoice_year"
                aria-label="Select Report Year"
                defaultValue={moment().format("YYYY")}
                ref={register({
                  required: false,
                })}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                {totalYearsList()}
              </select>
            </li>

            <li className="inline-block text-xs leading-8 w-1/2 mb-4">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Upload Type
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="invoice_erase_existing"
                aria-label="Select Upload Type"
                value={invoiceEraseExisting}
                ref={register({
                  required: true,
                })}
                onChange={(e) => {
                  const val = e.target.value;
                  setInvoiceEraseExisting(val);
                  if (val !== "" && invoiceMonthSelected) {
                    setInvDisableProp("");
                  } else {
                    setInvDisableProp("disabled");
                  }
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-11/12 text-fogotpwsd_login text-sm"
              >
                <option value="">Select Upload Type</option>
                <option value="F">Add to Existing</option>
                <option value="T">Delete Existing</option>
              </select>
            </li>
            <li className="inline-block text-xs leading-8 w-full">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Upload Invoice
              </label>
              <input
                id="invoice"
                name="invoice"
                type="file"
                onChange={invoiceFileUpload}
                ref={register({
                  required: true,
                })}
                disabled={disableInvProp}
                className="focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-1/2"
              />
            </li>
          </ul>
        </div>
        <div className="pt-5 pb-4">
          <ul className="text-left">
            <li className="inline-block text-xs leading-6 w-1/2">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Parent
              </label>
              <select
                name="parent"
                aria-label="Select Parent"
                ref={register({
                  required: false,
                })}
                id="parent"
                onChange={(e) => {
                  getFacilities(e.target.value);
                  setParSelected(e.target.value);
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-11/12 text-fogotpwsd_login text-sm"
              >
                <option value="">Select Parent</option>
                {parentsList
                  ? parentsList.map((parent, i) => {
                      return (
                        <option key={i} value={parent}>
                          {parent}
                        </option>
                      );
                    })
                  : null}
              </select>
            </li>
            <li className="inline-block text-xs leading-6 w-1/2">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Facility
              </label>
              <select
                name="facility"
                aria-label="Select Facility"
                ref={register({
                  required: false,
                })}
                onChange={(e) => {
                  setFacSelected(e.target.value);
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="0">Select Facility</option>
                {facList
                  ? facList.map((facility, i) => {
                      return (
                        <option key={i} value={facility.id}>
                          {facility.name}
                        </option>
                      );
                    })
                  : null}
              </select>
            </li>
            <li className="inline-block text-xs leading-8 w-1/2 mb-4">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Report Month
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="invoice_month_othr"
                aria-label="Select Report Month"
                ref={register({
                  required: true,
                })}
                onChange={(e) => {
                  const monthSelected = e.target.value !== "";
                  setOthrMonthSelected(monthSelected);
                  if (monthSelected && eraseExisting !== "") {
                    setOthrDisableProp("");
                  } else {
                    setOthrDisableProp("disabled");
                  }
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-11/12 text-fogotpwsd_login text-sm"
              >
                <option value="">Select Report Month</option>
                {totalMonths
                  ? totalMonths.map((monthName, i) => {
                      return (
                        <option key={i} value={("0" + (i + 1)).slice(-2)}>
                          {monthName}
                        </option>
                      );
                    })
                  : null}
              </select>
            </li>
            <li className="inline-block text-xs leading-8 w-1/2 mb-4">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Report Year
              </label>
              <select
                name="invoice_year_othr"
                aria-label="Select Report Year"
                defaultValue={moment().format("YYYY")}
                ref={register({
                  required: false,
                })}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                {totalYearsList()}
              </select>
            </li>
            <li className="inline-block text-xs leading-8 w-1/2 mb-4">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Upload Type
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1">*</span>
              <select
                name="erase_existing"
                aria-label="Select Upload Type"
                value={eraseExisting}
                ref={register({
                  required: true,
                })}
                onChange={(e) => {
                  const val = e.target.value;
                  setEraseExisting(val);
                  if (val !== "" && othrMonthSelected) {
                    setOthrDisableProp("");
                  } else {
                    setOthrDisableProp("disabled");
                  }
                }}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-11/12 text-fogotpwsd_login text-sm"
              >
                <option value="">Select Upload Type</option>
                <option value="F">Add to Existing</option>
                <option value="T">Delete Existing</option>
              </select>
            </li>
          </ul>
        </div>
        <div className="pt-5 pb-4 border-b-2">
          <ul className="text-left">
            <li className="inline-block text-xs leading-8 w-1/2">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Upload Backup
              </label>
              <input
                id="backup"
                name="backup"
                type="file"
                onChange={invoiceFileUpload}
                ref={register({
                  required: true,
                })}
                disabled={disableOthrProp}
                className="focus:outline-none focus:none h-10 rounded-md pl-8 text-sm font-normal w-1/2"
              />
            </li>
            <li className="inline-block text-xs leading-8 w-1/2">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Upload MedSurge
              </label>
              <input
                id="medsurge"
                name="medsurge"
                type="file"
                onChange={invoiceFileUpload}
                ref={register({
                  required: true,
                })}
                disabled={disableOthrProp}
                className="focus:outline-none focus:none h-10 rounded-md pl-2 text-sm font-normal w-1/2"
              />
            </li>
            <li className="inline-block text-xs leading-8 w-1/2">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Upload IV Services
              </label>
              <input
                id="iv_service"
                name="iv_service"
                type="file"
                onChange={invoiceFileUpload}
                ref={register({
                  required: true,
                })}
                disabled={disableOthrProp}
                className="focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal w-1/2"
              />
            </li>
            <li className="inline-block text-xs leading-8 w-1/2">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Other Fee Type
              </label>
              <input
                id="fee_type"
                name="fee_type"
                type="file"
                onChange={invoiceFileUpload}
                ref={register({
                  required: true,
                })}
                disabled={disableOthrProp}
                className="focus:outline-none focus:none h-10 rounded-md pl-4 text-sm font-normal w-1/2 ml-2"
              />
            </li>
          </ul>
        </div>
        <div className="pt-5 pb-4">
          <ul className="text-left">
            <li className="inline-block text-xs leading-8 w-1/2">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Upload Addresses
              </label>
              <input
                id="address"
                name="address"
                type="file"
                onChange={invoiceFileUpload}
                ref={register({
                  required: true,
                })}
                className="focus:outline-none focus:none h-10 rounded-md pl-4 text-sm font-normal w-1/2 ml-2"
              />
            </li>
            <li className="inline-block text-xs leading-8 w-1/2">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Upload Profiles
              </label>
              <input
                id="profile"
                name="profile"
                type="file"
                onChange={invoiceFileUpload}
                ref={register({
                  required: true,
                })}
                disabled={disableOthrProp}
                className="focus:outline-none focus:none h-10 rounded-md pl-4 text-sm font-normal w-1/2 ml-2"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(UploadInvoice)
);
